import {
  Intent,
  Position,
  Toaster,
} from '@blueprintjs/core';

import { api } from './Api';

const subscriptionToaster = Toaster.create({
  className: 'subscription-toaster',
  position: Position.TOP
});

const showToaster = (error: any) => {
  const message = error.response?.data?.message || "Unknown error";
  subscriptionToaster.show({
    message: `${message}`,
    intent: Intent.DANGER
  });
}

const startTrialToaster = (res: any) => {
  subscriptionToaster.show({
    message: 'Trial period successfully started',
    intent: Intent.SUCCESS
  });
}

export const subscriptionLoadProducts = () => {
  return api
    .post(`/subscription/product/list`)
    .then((res: any) => res.data?.products || [])
    .catch(showToaster)
}

export const subscriptionCheckoutSession = (
  productId: string,
  priceId: string,
  interval: string,
  minQuantity: number,
  maxQuantity: number,
) => {
  /*
  Redirect to Stripe checkout;

  Response contains a redirect url
   */
  const payload = {
    product_id: productId,
    price_id: priceId,
    interval,
    min_quantity: minQuantity,
    max_quantity: maxQuantity
  }

  return api
    .post(`/subscription/checkout_session`, payload)
    .then((res: any) => res.data)
    .catch(showToaster)
}

export const subscriptionCustomerPortal = () => {
  /*
  Redirect to customer portal
   */
  return api
    .post(`/subscription/portal_session`)
    .then((res: any) => res.data)
    .catch(showToaster)
}

export const subscriptionStartTrial = () => {
  return api
    .post(`/subscription/start_trial`)
    .then(startTrialToaster)
    .catch(showToaster)
}
